export default __webpack_public_path__ + "static/media/profile navigate.7bdd9179.jpg";